var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_956_629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99953 8.09222C10.3659 8.09222 12.2842 6.38062 12.2842 4.26925C12.2842 2.15789 10.3659 0.446289 7.99953 0.446289C5.63316 0.446289 3.71484 2.15789 3.71484 4.26925C3.71484 6.38062 5.63316 8.09222 7.99953 8.09222Z",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99964 9.54443C3.87024 9.54443 0.5 11.3456 0.5 13.5316V15.5534H15.4935V13.5316C15.4935 11.3456 12.0945 9.54443 7.99389 9.54443H7.99964Z",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_956_629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/personIcon.a42e71b2da914581b7624d6bf0615683.svg";
export { ForwardRef as ReactComponent };